import { render } from "./Main.vue?vue&type=template&id=7bb3112a&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=7bb3112a&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境/M平台/前端/servicepartner.matchupexpo.com - 外呼合作方端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb3112a"]])

export default __exports__